module.exports = __webpack_public_path__ + "img/target (1).3d7ed4b0.svg";